// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3md1y","boxTitle":"Qualiphy_boxTitle__22Viv","box":"Qualiphy_box__r0Q0R","toggleWrap":"Qualiphy_toggleWrap__PmaHc"};